<div class="bottom-sheet-container">
  <!-- Header -->
  <div class="bottom-sheet-header" style="display: flex; justify-content: flex-end; align-items: center;">
    <button mat-icon-button (click)="close()" matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Chart -->
  <div class="chart-container">
    <div [id]="chartItemId" [chart]="chartData" class="highcharts-container"></div>
  </div>
</div>
